import React from "react";
import { Box, Typography } from "@mui/material";
import IconBox from "../atoms/IconBox";
import { useClinicTheme } from "../../theme";

/**
 * Sayfa başlığı: ikon + başlık + alt başlık (molecule).
 */
export default function PageTitle({ icon, title, subtitle, iconSize = 52 }) {
  const { palette } = useClinicTheme();
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, minWidth: 0 }}>
      <IconBox icon={icon} size={iconSize} />
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h5" sx={{ fontWeight: 900, color: palette.primary, lineHeight: 1.2 }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 600 }}>
            {subtitle}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
}
